// Shared comparison rules. Work messages keep their activity/trail owner and
// are never folded into ordinary Chat response cards.
export function groupAssistantReplies(messages, previousGroups = new Map(), work = false) {
  const items = [], nextGroups = new Map(), occurrences = new Map();
  for (const message of messages || []) {
    const parent = message.parentMessageId;
    const last = items[items.length - 1];
    if (!work && message.role === 'assistant' && parent) {
      if (last?.type === 'group' && last.parentMessageId === parent) last.messages.push(message);
      else {
        const occurrence = occurrences.get(parent) || 0; occurrences.set(parent, occurrence + 1);
        items.push({ type: 'group', id: `group-${parent}${occurrence ? `-${occurrence}` : ''}`, parentMessageId: parent, messages: [message], role: 'assistant' });
      }
    } else items.push(message);
  }
  for (let index = 0; index < items.length; index++) {
    const group = items[index];
    if (group.type !== 'group') continue;
    const previous = previousGroups.get(group.id);
    if (previous?.messages.length === group.messages.length && previous.messages.every((message, i) => message === group.messages[i])) items[index] = previous;
    nextGroups.set(group.id, items[index]);
  }
  return { items, nextGroups };
}

export function responsePreview(content, maxLength = 120) {
  if (typeof content !== 'string') return '';
  const plain = content.replace(/<[^>]*>/g, '').replace(/```[\s\S]*?```/g, '[code]').replace(/`[^`]+`/g, '[code]')
    .replace(/[#*_~\[\]()>]/g, '').replace(/\n+/g, ' ').trim();
  return plain.length > maxLength ? plain.slice(0, maxLength).trim() + '...' : plain;
}

export const responseGridStyle = { flexDirection: 'row', flexWrap: 'wrap', gap: 12 };
export const responseColumnStyle = (small, platform) => ({ width: small ? '100%' : platform === 'web' ? 'calc(50% - 6px)' : '48%', minWidth: small ? undefined : 280 });

export function comparisonMediaResponse(message) {
  const document = ['document', 'presentation', 'spreadsheet'].includes(message.isRequestingMedia);
  if (message.isRequestingMedia && !document || message.isImage) return true;
  if (Array.isArray(message.images) && message.images.some(image => image && (image.url || image.cdnPath || image.src || image.uri || image.imageUrl))) return true;
  const files = Array.isArray(message.files) && message.files.some(file => file && (['image', 'video', 'audio', '3d'].includes(file.fileType)
    || /^(image|video|audio)\//.test(file.type || file.mimeType || '') || ['model/gltf-binary', 'model/gltf+json'].includes(file.type)));
  const text = typeof message.content === 'string' ? message.content : Array.isArray(message.content)
    ? message.content.filter(part => part?.type === 'text' && typeof part.text === 'string').map(part => part.text).join('\n') : '';
  return !!files && text.trim().length < 50;
}
